import { combineReducers } from "redux";
import axios from "axios";
import { API } from "../../../../../const";
import { unAuthorized } from "../../../../auth/Auth.ducks";
import { Service } from "../../../../service/service";
import _ from "lodash";

export const FETCH_EVENT_PENDING = "FETCH_EVENT_PENDING";
export const FETCH_EVENT_REJECTED = "FETCH_EVENT_REJECTED";
export const FETCH_EVENT_FULFILLED = "FETCH_EVENT_FULFILLED";

export const GET_NEXT_EVENT_PARTICIPANTS_PENDING =
  "GET_NEXT_EVENT_PARTICIPANTS_PENDING";
export const GET_NEXT_EVENT_PARTICIPANTS_REJECTED =
  "GET_NEXT_EVENT_PARTICIPANTS_REJECTED";
export const GET_NEXT_EVENT_PARTICIPANTS_FULFILLED =
  "GET_NEXT_EVENT_PARTICIPANTS_FULFILLED";

const INITIAL_STATE = {
  participants: [],
  eventDetails: {},
};

const loading = (state = INITIAL_STATE, { type }) => {
  switch (type) {
    case FETCH_EVENT_PENDING:
    case GET_NEXT_EVENT_PARTICIPANTS_PENDING:
      return true;
    case FETCH_EVENT_REJECTED:
    case FETCH_EVENT_FULFILLED:
    case GET_NEXT_EVENT_PARTICIPANTS_REJECTED:
    case GET_NEXT_EVENT_PARTICIPANTS_FULFILLED:
      return false;
    default:
      return state;
  }
};

const error = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_EVENT_PENDING:
    case FETCH_EVENT_FULFILLED:
    case GET_NEXT_EVENT_PARTICIPANTS_PENDING:
    case GET_NEXT_EVENT_PARTICIPANTS_FULFILLED:
      return null;
    case FETCH_EVENT_REJECTED:
    case GET_NEXT_EVENT_PARTICIPANTS_REJECTED:
      return payload;
    default:
      return state;
  }
};

const event = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FETCH_EVENT_FULFILLED:
      return Object.assign({}, state, {
        eventDetails: _.isEmpty(payload.data) ? null : payload.data,
      });

    case GET_NEXT_EVENT_PARTICIPANTS_FULFILLED:
      return Object.assign({}, state, {
        participants: _.isEmpty(payload.data)
          ? null
          : payload.data.participants,
      });

    default:
      return state;
  }
};

export default combineReducers({ loading, error, event });

export const fetchEvent = (tok) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/creche/events/next`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: FETCH_EVENT_FULFILLED, payload: res });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: FETCH_EVENT_REJECTED, payload: err });
      if (err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};
export const getNextEventParticipants = (tok) => {
  return (dispatch) => {
    const response = Service.get(`${API}api/creche/events/next/participants`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: GET_NEXT_EVENT_PARTICIPANTS_FULFILLED, payload: res });
    });
  };
};
